import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { MandatesApiService } from 'src/app/core/mandates-api/mandates-api.service';

@Injectable({
  providedIn: 'root',
})
export class StagingMandateStateService {

  public hasAccess$ = new BehaviorSubject<boolean>(false);
  public hasUnapproved$ = new BehaviorSubject<boolean>(false);

  constructor(
    private mandatesApiService: MandatesApiService
  ) {}

  public requestIndicators(): void {
    this.mandatesApiService.getStagingMandateIndicators().subscribe({
      next: (indicators) => {
        this.hasAccess$.next(indicators.hasAccess);
        this.hasUnapproved$.next(indicators.hasUnapproved);
      },
      error: (error) => {
        this.hasAccess$.next(false);
        this.hasUnapproved$.next(false);
        console.error('Failed to get staging mandate indicators:', error);
      },
    });
  }
}
